import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Injector,
  Input,
} from "@angular/core";
import { TooltipComponent } from "../components/tooltip/tooltip.component";
import { DOCUMENT } from "@angular/common";
import { Sale } from "../interfaces/sale";

@Directive({
  selector: "[appTooltip]",
})
export class TooltipDirective {
  @Input("appTooltip") tooltipText: string = "";
  @Input() tooltipPosition: "top" | "bottom" | "left" | "right" = "right";
  @Input() selectedConversation: any = null;
  @Input() customerSales: Sale[] = [];
  @Input() saleCount!: number;
  @Input() lastSaleDate!: string;
  @Input() detailAddressUser = "";
  private tooltipComponent?: ComponentRef<any>;

  @HostListener("mouseenter")
  onMouseEnter(): void {
    if (this.tooltipComponent) {
      return;
    }

    const tooltipComponentFactory =
      this.componentFactoryResolver.resolveComponentFactory(TooltipComponent);
    this.tooltipComponent = tooltipComponentFactory.create(this.injector);
    this.appRef.attachView(this.tooltipComponent.hostView);
    this.document.body.appendChild(
      this.tooltipComponent.location.nativeElement,
    );

    this.setTooltipComponentProperties();
    this.tooltipComponent.hostView.detectChanges();
  }

  @HostListener("mouseleave")
  onMouseLeave(): void {
    if (!this.tooltipComponent) {
      return;
    }
    this.appRef.detachView(this.tooltipComponent.hostView);
    this.tooltipComponent.destroy();
    this.tooltipComponent = undefined;
  }

  private setTooltipComponentProperties() {
    if (!this.tooltipComponent) {
      return;
    }

    this.tooltipComponent.instance.text = this.tooltipText;
    this.tooltipComponent.instance.position = this.tooltipPosition;
    this.tooltipComponent.instance.selectedConversation =
      this.selectedConversation;
    this.tooltipComponent.instance.customerSales = this.customerSales;
    this.tooltipComponent.instance.saleCount = this.saleCount;
    this.tooltipComponent.instance.lastSaleDate = this.lastSaleDate;
    this.tooltipComponent.instance.detailAddressUser = this.detailAddressUser;

    const { left, right, top, bottom } =
      this.elementRef.nativeElement.getBoundingClientRect();
    const tooltipWidth =
      this.tooltipComponent.location.nativeElement.offsetWidth;
    const tooltipHeight =
      this.tooltipComponent.location.nativeElement.offsetHeight;

    switch (this.tooltipPosition) {
      case "top":
        this.tooltipComponent.instance.left =
          (right - left) / 2 + left - tooltipWidth / 2;
        this.tooltipComponent.instance.top = top - tooltipHeight - 5;
        break;
      case "bottom":
        this.tooltipComponent.instance.left =
          (right - left) / 2 + left - tooltipWidth / 2;
        this.tooltipComponent.instance.top = bottom + 5;
        break;
      case "left":
        this.tooltipComponent.instance.left = left - tooltipWidth - 5;
        this.tooltipComponent.instance.top =
          (bottom - top) / 2 + top - tooltipHeight / 2;
        break;
      case "right":
        this.tooltipComponent.instance.left = right + 5;
        this.tooltipComponent.instance.top =
          (bottom - top) / 2 + top - tooltipHeight / 2;
        break;
    }
  }

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private elementRef: ElementRef,
    private appRef: ApplicationRef,
    @Inject(DOCUMENT) private document: Document,
  ) {}
}
